import { slugify } from '@/utils/text-utils';
import { Chip, IconButton } from '@destination/components';
import { useTranslation } from 'react-i18next';
import ExternalLinkIcon from '@icons/external_link.svg?react';
import { IIdentity } from '@/models/IIdentity';

export interface IDeviceModelFunctionalityList {
  functionalities: IIdentity[];
  'data-testid'?: string;
}

export default function DeviceModelFunctionalityList({
  functionalities,
  'data-testid': dataTestId
}: IDeviceModelFunctionalityList) {
  const { t } = useTranslation(undefined, { keyPrefix: 'model.device_model' });

  function openInNewTab(url: string) {
    const win = window.open(url, '_blank');
    if (win) win.focus();
  }

  return (
    <div data-testid={dataTestId}>
      {functionalities.map(functionality => (
        <div
          className="hover:cursor-pointer text-base flex justify-between tw-rounded-md mb-2 bg-slate-50 tw-bg-white tw-p-4 tw-shadow-[0_4px_20px_0_rgba(0,0,0,0.1)] p-2 pl-3"
          key={'functionality-' + slugify(functionality.key)}
          onClick={() =>
            openInNewTab(
              `/models/browse?type=functionality&key=${functionality.key}&module=${functionality.module}&version=${functionality.version}&strict=true`
            )
          }
        >
          <div className="flex">
            <div>
              {t('module')}:{' '}
              <Chip label={functionality.module} className="ml-2" />
            </div>
            <div className="ms-4">
              {t('key')}: <Chip label={functionality.key} className="ml-2" />
            </div>
            <div className="ms-4">
              {' '}
              {t('version')}:{' '}
              <Chip label={functionality.version} className="ml-2" />
            </div>
          </div>
          <IconButton>
            <ExternalLinkIcon width={16} />
          </IconButton>
        </div>
      ))}
    </div>
  );
}
